(function () {
  'use strict';

  var PENDING_KEY = 'xsto.inquiry.pending.v1';
  var CONTACT_PATH = '/pages/contact';
  var TRIAL_PATH = '/pages/trial-demo';
  var TTL_MS = 30 * 60 * 1000;
  var PURPOSES = ['購入・導入相談', '製品選び・購入相談', '試乗・デモ', '法人見積り・現場相談', '納期確認', '修理・保証・交換部品', 'その他'];
  var PRODUCT_LABELS = { M4: 'm4', 'M4 Pro': 'm4-pro', X12: 'x12', 'X12 Pro': 'x12-pro', EzGo2: 'ezgo2', 'EzGo2 Pro': 'ezgo2-pro', CT50: 'ct50-ai-stair-climber' };
  var NON_PRODUCT_CHOICES = ['未定', 'まだ決まっていない', 'その他', '純正アクセサリー', '階段・搬送製品'];
  var PRODUCT_RE = /^[A-Za-z0-9][A-Za-z0-9+._-]{1,40}$/;
  var REF_RE = /^\/(?!\/)[^\s<>"'`\\]*$/;
  var PATH_RE = /^\/(?!\/)[^\s?#<>"'`\\]*$/;

  function normalizedPath(pathname) {
    return String(pathname || '/').replace(/\/+$/, '') || '/';
  }

  function safeProduct(value) {
    return typeof value === 'string' && value.length <= 41 && PRODUCT_RE.test(value) ? value.toLowerCase() : '';
  }

  function safeRef(value) {
    if (typeof value !== 'string' || value.length === 0 || value.length > 200 || !REF_RE.test(value)) return '';
    try {
      return new URL(value, window.location.origin).origin === window.location.origin ? value : '';
    } catch (error) {
      return '';
    }
  }

  function sourcePath(ref) {
    try {
      var pathname = ref ? new URL(ref, window.location.origin).pathname : window.location.pathname;
      return typeof pathname === 'string' && pathname.length <= 200 && PATH_RE.test(pathname) ? pathname : '/';
    } catch (error) {
      return '/';
    }
  }

  function localInquiryTarget(anchor) {
    try {
      var href = anchor.getAttribute('href');
      if (!href) return null;
      var url = new URL(href, window.location.href);
      var path = normalizedPath(url.pathname);
      return url.origin === window.location.origin && (path === CONTACT_PATH || path === TRIAL_PATH) ? { url: url, path: path } : null;
    } catch (error) {
      return null;
    }
  }

  function addTrialContext() {
    if (normalizedPath(window.location.pathname) !== TRIAL_PATH) return;
    var page = new URL(window.location.href);
    var product = safeProduct(page.searchParams.get('product') || '');
    var ref = safeRef(page.searchParams.get('ref') || '') || sourcePath('');

    document.querySelectorAll('a[href]').forEach(function (anchor) {
      var target = localInquiryTarget(anchor);
      if (!target || target.path !== CONTACT_PATH) return;
      var params = new URLSearchParams();
      if (product) params.set('product', product);
      if (ref) params.set('ref', ref);
      params.set('purpose', '試乗・デモ');
      anchor.setAttribute('href', CONTACT_PATH + '?' + params.toString() + target.url.hash);
    });
  }

  function publish(name, data, onTrue) {
    try {
      var api = window.Shopify && window.Shopify.analytics;
      if (!api || typeof api.publish !== 'function') return;
      var result = api.publish(name, data);
      if (result === true) {
        if (onTrue) onTrue();
      } else if (result && typeof result.then === 'function') {
        result.then(function (dispatched) {
          if (dispatched === true && onTrue) onTrue();
        }, function () {});
      }
    } catch (error) {
      /* Analytics failures must not block navigation or form submission. */
    }
  }

  function ctaPosition(anchor) {
    if (!anchor.closest) return 'content_link';
    if (anchor.closest('[data-xsto-mobile-contact], .xsto-mobile-contact')) return 'mobile_shortcut';
    if (anchor.closest('.xsto-mobility-selection')) return 'collection_selection';
    if ((anchor.hasAttribute && anchor.hasAttribute('data-xsto-primary-contact')) || anchor.closest('.xsto-product-summary, .xsto-product-inquiry')) return 'product_primary';
    if (anchor.closest('header, .header, .header__drawer')) return 'site_header';
    if (anchor.closest('footer, .footer')) return 'site_footer';
    if (anchor.closest('.xsto-actions')) return 'section_cta';
    return 'content_link';
  }

  function onClick(event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!anchor) return;
    var target = localInquiryTarget(anchor);
    if (!target) return;

    var params = target.url.searchParams;
    var product = safeProduct(params.get('product') || '');
    var purpose = params.get('purpose') || '';
    if (PURPOSES.indexOf(purpose) === -1) purpose = target.path === TRIAL_PATH ? '試乗・デモ' : '';
    var data = { cta_position: ctaPosition(anchor), source_path: sourcePath(''), destination_path: target.path };
    if (product) data.product_handle = product;
    if (purpose) data.purpose = purpose;
    publish('xsto_inquiry_clicked', data);
  }

  function formContext(form) {
    var params = new URLSearchParams(window.location.search || '');
    var productField = form.querySelector('#XstoContact-product');
    var purposeField = form.querySelector('#XstoContact-purpose');
    var product = productField
      ? (PRODUCT_LABELS[productField.value] || (NON_PRODUCT_CHOICES.indexOf(productField.value) === -1 ? safeProduct(productField.value) : ''))
      : safeProduct(params.get('product') || '');
    var purpose = purposeField ? purposeField.value : params.get('purpose');
    var context = { source_path: sourcePath(safeRef(params.get('ref') || '')) };
    if (product) context.product_handle = product;
    if (PURPOSES.indexOf(purpose) !== -1) context.purpose = purpose;
    return context;
  }

  function inquiryId(timestamp) {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch (error) {}
    return 'i-' + timestamp.toString(36) + '-' + Math.random().toString(36).slice(2, 14);
  }

  function onSubmit(event) {
    try {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form.xsto-contact-form')) return;
      var submittedAt = Date.now();
      var record = Object.assign({
        id: inquiryId(submittedAt),
        submitted_at: new Date(submittedAt).toISOString(),
        completed: false
      }, formContext(form));
      window.sessionStorage.setItem(PENDING_KEY, JSON.stringify(record));
    } catch (error) {
      /* The native form submission continues when browser storage is blocked. */
    }
  }

  function pendingRecord(storage) {
    try {
      var value = JSON.parse(storage.getItem(PENDING_KEY) || 'null');
      var submittedAt = value && Date.parse(value.submitted_at);
      if (!value || !/^[A-Za-z0-9-]{8,80}$/.test(value.id || '') || !Number.isFinite(submittedAt) || Date.now() - submittedAt > TTL_MS || submittedAt > Date.now() + 60000 || !PATH_RE.test(value.source_path || '')) return null;
      var record = { id: value.id, submitted_at: value.submitted_at, source_path: value.source_path, completed: value.completed === true };
      if (safeProduct(value.product_handle) === value.product_handle) record.product_handle = value.product_handle;
      if (PURPOSES.indexOf(value.purpose) !== -1) record.purpose = value.purpose;
      return record;
    } catch (error) {
      return null;
    }
  }

  function confirmedSuccess() {
    if (!document.querySelector('[data-xsto-contact-success]')) return;
    var storage;
    try { storage = window.sessionStorage; } catch (error) { return; }
    var record = pendingRecord(storage);
    if (!record || record.completed) {
      try { storage.removeItem(PENDING_KEY); } catch (error) {}
      return;
    }

    var data = { inquiry_id: record.id, submitted_at: record.submitted_at, source_path: record.source_path, form_path: sourcePath('') };
    if (record.product_handle) data.product_handle = record.product_handle;
    if (record.purpose) data.purpose = record.purpose;
    publish('xsto_inquiry_submitted', data, function () {
      try { storage.setItem(PENDING_KEY, JSON.stringify(Object.assign({}, record, { completed: true }))); } catch (error) {}
      try { storage.removeItem(PENDING_KEY); } catch (error) {}
    });
  }

  function initialize() {
    addTrialContext();
    document.addEventListener('click', onClick, true);
    document.addEventListener('submit', onSubmit, true);
    confirmedSuccess();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
